import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/layout.css';
import './assets/styles/404.css';
import './assets/styles/welcome.css';
import './assets/styles/getting-started.css';
import './assets/styles/join.css';
import './assets/styles/connect.css';
import './assets/styles/reward.css';
import './assets/styles/static-content.css';
import './assets/styles/community.css';
import './assets/styles/dashboard.css';
import './assets/styles/account.css';
import './assets/styles/loader.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configLoader from './helpers/configs/ConfigLoader';
import dataStore from './helpers/store/GlobalDataStore';

dataStore.set('env_config', configLoader.toObject());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
